export default {
  borderColorDisabled: 'none',
  backgroundDisabled: 'var(--light-grey)',
  backgroundEnabled: 'var(--mpc)',
  backgroundEnabledValidatedSMS: 'var(--cta-color)',
};
